module.exports = __webpack_public_path__ + "static/img/CUROSTAIN-logo.8aab8dc5.svg";